import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '../utils/className';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'size-4 shrink-0 rounded-xs shadow disabled:cursor-not-allowed ' +
        'bg-fill-input-neutral-idle border border-border-input-neutral-idle ' +
        'hover:border-border-input-neutral-hover hover:bg-fill-input-neutral-hover ',
      'active:border-border-input-neutral-active active:bg-fill-input-neutral-active ' +
        'disabled:border-border-input-neutral-disabled disabled:bg-fill-input-neutral-disabled ',
      'hover:disabled:border-border-input-neutral-disabled hover:disabled:bg-fill-input-neutral-disabled ',
      'data-[state=checked]:border-border-input-emphasis-idle data-[state=checked]:bg-fill-input-emphasis-idle ' +
        'hover:data-[state=checked]:border-border-input-emphasis-hover hover:data-[state=checked]:bg-fill-input-emphasis-hover ' +
        'active:data-[state=checked]:border-border-input-emphasis-active active:data-[state=checked]:bg-fill-input-emphasis-active ' +
        'disabled:data-[state=checked]:border-border-input-emphasis-disabled disabled:data-[state=checked]:bg-fill-input-emphasis-disabled ',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      {props.checked === 'indeterminate' ? (
        <Minus className="size-4 stroke-icon-input-emphasis-idle" />
      ) : (
        <Check className="size-4 stroke-icon-input-emphasis-idle" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
